<template>
    <div class="container-fluid">
        <admin-header :name="$t('Vehicles')" @create="newVehicle" :add-new="addNewBtn"/>
        <app-card class="mb-4">
            <router-view name="vehicles"/>
        </app-card>
    </div>
</template>

<script>
export default {
    computed: {
        addNewBtn() {
            return this.$route.fullPath === '/auth/vehicles' || this.$route.fullPath === '/auth/vehicles/';
        }
    },
    methods: {
        newVehicle() {
            this.$router.push({name:'vehicles.create'});
        }
    },
    metaInfo() {
        return {
            title: this.$t('Vehicles')
        };
    }
};
</script>
